$(function () {
    $(document).on("change", ".select-collection", function () {
        $("#filter-form").submit();
    });
    
    $(document).on("change", ".select-category", function () {
        $("#filter-form").submit();
    });

});